<script setup lang="ts">
defineProps<{
  onClick?: () => void;
}>();
</script>

<template>
  <div
    class="badge-wrapper"
    @click="onClick"
  >
    <div class="badge">
      <div class="glow" />
      <svg
        class="login-icon"
        fill="none"
        height="28"
        viewBox="0 0 32 28"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 4L22 14L12 24H10V18H0V10H10V4H12ZM22 24H28V4H22H20V0H22H30H32V2V26V28H30H22H20V24H22Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="spacer" />
  </div>
</template>

<style scoped lang="scss">
.badge-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
  z-index: 2;
}

.badge {
  position: absolute;
  // same alignment as HomeBadge — centers badge within center-bump
  top: -26px;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(
    ellipse 120% 150% at 40% -15%,
    #ff7049 0%,
    #ff3400 100%
  );
  box-shadow: 0 4px 24px rgba(255, 52, 0, 0.65);

  .glow {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    box-shadow: inset 0 4px 12px rgba(255, 255, 255, 0.3);
  }
}

.login-icon {
  position: relative;
  z-index: 1;
  margin-right: 4px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25));
}

.spacer {
  width: 62px;
  height: 30px;
}
</style>
